import { Skeleton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getTotalAgreementsList } from "../../utilities/apis/agreements";
import { loadingStates } from "../../utilities/utilities";

function AgreementGraph1({ configs }) {
  const years =
    configs?.data?.agreementByYear?.length > 0
      ? configs.data.agreementByYear
          .map((item) => item.year)
          .sort((a, b) => a - b)
      : [new Date().getFullYear()];
      
  const dataCounts = years.map((year) => {
    const yearData = configs?.data?.agreementByYear?.find(
      (el) => el.year === year,
    );
    return yearData ? yearData["_count"].id : 0;
  });
  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex flex-col">
        <div className="h-10" />

        <div className="mt-4 ml-2 text-slate-600 font-medium">Yearly Stats</div>

        {configs.loading === loadingStates.LOADING && (
          <Skeleton style={{ height: "200px" }} className="mt-4 mx-8" visible />
        )}
        {configs.loading === loadingStates.NO_ACTIVE_REQUEST &&
          configs.data.agreementByYear && (
            <div
              className="w-full mt-4"
              style={{
                height: "320px",
              }}
            >
              <Bar
                data={{
                  labels: years.map((year) => `${year}`),
                  datasets: [
                    {
                      label: "Contracts",
                      backgroundColor: "#1b6f8d",
                      barThickness: 30,
                      barPercentage: 0.5,
                      borderRadius: 10,
                      data: dataCounts,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      position: "top",
                      display: false,
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: "contracts",
                      },
                      grid: {
                        display: false, // Remove grid lines
                      },
                      ticks: {
                        display: false,
                      },
                    },
                    x: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        // text: 'No. of Agreement Completed Month wise',
                        text: "year",
                      },
                      grid: {
                        display: false, // Remove grid lines
                      },
                    },
                  },
                }}
              />
            </div>
          )}
      </div>
    </div>
  );
}

export default AgreementGraph1;
